(ns hai.ui.components.mahdi-table
  "Cooked to the taste of the boss
  https://www.figma.com/board/KdqgVKYaUnrDzLtQ3bTzuK/Workflows-%7C-Discussion?node-id=670-7421&t=G7YoiTlcj0NG8XS8-0
  "
  (:require
   [clojure.string :as str]
   [hai.ui.components :as c]
   [hai.ui.components.error :as error]
   [hai.ui.icons :as icons]
   [hai.ui.rf-sugar :refer [<s >e]]
   [humbleai.belt.csv :as csv]
   [humbleai.belt.download :as download]
   [lambdaisland.ornament :as o]))

(o/defstyled radio-segments :div
  []
  ([values]
   (into
    [c/SegmentedControlRoot {:defaultValue (ffirst values)}
     (for [[v s] values]
       [c/SegmentedControlItem {:value v} s])])))

(o/defstyled plain :div
  :flex :flex-col :gap-3
  [:.controls :flex :gap-3 :items-center]
  [:th {:color c/--gray-10
        :line-height c/--line-height-5}]
  [:.buttons :flex :flex-row :gap-3]
  [:.rt-TableHeader {c/--table-row-background-color c/--color-background}]
  [:.rt-TableRow:hover {c/--table-row-background-color c/--accent-2}]
  ["tr:nth-child(2n)" {c/--table-row-background-color c/--gray-2}]
  ([header rows]
   [c/TableRoot {:variant "surface"}
    [c/TableHeader
     (into
      [c/TableRow]
      (for [h header]
        [c/TableColumnHeaderCell h]))]
    (into
     [c/TableBody]
     (for [row rows]
       (into
        [c/TableRow]
        (for [cell row]
          [c/TableCell cell]))))]))

(o/defstyled remote-data-table :div
  "Most straightforward way to render data that we get from the platform, with
  handling of loading/error states.

  Kick off the request first with `(>e [:fetch {:url
  \"...\" :request-id :foo}])`, you can also use `:fetch-once` to prevent the
  request from happening on route/render changes. The table contains a refresh
  button & a csv-export button.

  Pass the request-id to the this component, together with {:header ... :render
  ...} maps, one for each column.
  "
  :relative
  [:>.reload-button     {:z-index "1" :position "absolute" :top "1rem" :right "2.5rem"}]
  [:>.csv-export-button {:z-index "1" :position "absolute" :top "1rem" :right "0.75rem"}]
  ([request-id & cols]
   (let [{:keys [state request response err]} @(<s [:fetch/request request-id])
         headers (map :header cols)]
     [:<>
      [c/Button {:class "reload-button" :variant "ghost"}
       [icons/filled-replay {:on-click #(>e [:fetch request])}]]

      [c/Button {:class "csv-export-button" :variant "ghost"}
       [icons/filled-download {:on-click (fn [_]
                                           (download/download! (str (name request-id) ".csv")
                                                               (csv/generate-str cols (:body response) {})
                                                               "text/csv"))}]]
      (cond
        (= :start state)
        [plain
         headers
         (for [_ (range 3)]
           (for [_ cols]
             [c/Skeleton]))]
        (= :error state)
        [error/error-card err]
        :else
        [plain
         headers
         (for [row (:body response)]
           (map #((:render %) row) cols))])])))
